import React, { useEffect, useState } from "react";
import { Formik, Form, FieldArray, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import { disabledStyle } from "../../../Common/ClickDisable";
import LoginLoaderButton from "../../../Common/Loader/LoginLoaderButton";
import { useDispatch } from "react-redux";
import { addRental, updateRental } from "../../../../redux/rental/action";
import CustomReactQuillDescription from "../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import DisplayFileProper from "../../../Common/FilesRelevent/DisplayFileProper";
import DownloadButton from "../../../Common/FilesRelevent/DownloadButton";
import { Commas } from "../../../Common/AllDateTimeReleventFormate";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import DisplayProper from "../../../Common/FilesRelevent/DisplayProper";
import ActiveHTMLDescription from "../../../Common/CustomeLabel/ReactQuill/ActiveHTMLDescription";

const bxpDatatomap = [
  { title: "Price in $", name: "price", placeholder: "Enter total cost" },
];

const PricingTerms = ({ updateindex, bxpData, setActiveTab, setModalOpen, setModal }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const initialValues = {
    // price: bxpData?.price || bxpData?.price_interpreter || "",
    payment_type: bxpData?.payment_type || "2",
    terms: bxpData?.terms || "",
    milestones: bxpData?.milestones || [
      {
        title: "",
        duration: "",
        amount: "",
      },
    ],
  };

  const validationSchema = Yup.object().shape({
    // price: Yup.string().required("Price is required"),
    payment_type: Yup.string().required("Payment terms are required"),
    terms: Yup.string(),
  });

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const updatedBxpData = {
        ...bxpData,
        payment_type: values.payment_type,
        terms: values.terms,
        milestones: values.milestones,
      };
      if (updateindex !== null) {
        dispatch(updateRental(updatedBxpData, setLoading));
      } else {
        dispatch(addRental(updatedBxpData, setLoading));
        localStorage.removeItem("TAI_DRAFT");
      }
      setModalOpen(false);
      setModal(false);
    } catch (error) {
      console.error("Error submitting BXP:", error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  const path = "Assets/scss/FirstTimeUsers.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formik) => (
          <Form>
            <div>
              {bxpDatatomap.map((prop, key) => {
                return (
                  <div className="d-flex flex-column price-flex">
                    <div className="price-duration">
                      <h6>Product name</h6>
                      <h4>{bxpData?.title}</h4>
                    </div>
                    <div className="price-duration">
                      <h6>Industry</h6>
                      <h4>{bxpData?.industry_index?.label || bxpData?.industry_title}</h4>
                    </div>
                    <div className="price-duration">
                      <h6>Category</h6>
                      <h4>{bxpData?.category_index?.label || bxpData?.category_title}</h4>
                    </div>
                    {bxpData?.sub_category_title && <div className="price-duration">
                      <h6>Sub category</h6>
                      <h4>{bxpData?.sub_category_title}</h4>
                    </div>}
                    {/* <div className="price-duration" >
                      <h6>Product price</h6>
                      <h4>$ {Commas(bxpData?.price)}</h4>
                    </div> */}
                    <div className="price-duration">
                      <h6>Cover photos</h6>

                      {Array.isArray(bxpData.files) &&
                        bxpData.files
                          .filter((cover_pic) => cover_pic.status != 3)
                          .map((cover_pic, indi) => (
                            <div
                              key={indi}
                              className="image-container mb-0 col-md-5 p-0 mb-3"
                            >
                              <DisplayFileProper item={{ file: cover_pic?.file }} />
                            </div>
                          ))}

                    </div>
                    {bxpData?.description &&
                      <div className="price-duration">
                        <h6>Description</h6>
                        <ActiveHTMLDescription
                          value={bxpData?.description}
                          key={updateindex || key}
                          displyreadorless={true}
                        />
                      </div>
                    }

                    <div className="price-duration">
                      <h6>Rental type</h6>
                      <h4>
                        {bxpData?.rental_only == 1 && !bxpData?.rental_with_interpreter && "Rental Only"} {bxpData?.rental_only == 1 && bxpData?.rental_with_interpreter == 1 && "Rental"}  {bxpData?.rental_only == 1 && bxpData?.rental_with_interpreter == 1 && "&"}{" "}
                        {bxpData?.rental_with_interpreter == 1
                          ? "Rental With Interpreter"
                          : ""}
                      </h4>
                    </div>
                    {bxpData?.rental_only == 1 && (
                      <div className="price-duration">
                        <h6>Rental price</h6>
                        <h4>
                          $ {bxpData?.price}/
                          {bxpData?.price_type == 1
                            ? "hour"
                            : bxpData?.price_type == 2
                              ? "day"
                              : bxpData?.price_type == 3
                                ? "weeks"
                                : bxpData?.price_type == 4
                                  ? "months"
                                  : ""}
                        </h4>
                      </div>
                    )}
                    {bxpData?.rental_with_interpreter == 1 && (
                      <div className="price-duration">
                        <h6>Rental with interpreter price</h6>
                        <h4>
                          $ {bxpData?.price_interpreter}/
                          {bxpData?.price_type_interpreter == 1
                            ? "hour"
                            : bxpData?.price_type_interpreter == 2
                              ? "day"
                              : bxpData?.price_type_interpreter == 3
                                ? "weeks"
                                : bxpData?.price_type_interpreter == 4
                                  ? "months"
                                  : ""}
                        </h4>
                      </div>
                    )}
                  </div>
                );
              })}
              <div className="button-container">
                <p
                  style={loading ? disabledStyle : {}}
                  className="prev-button w-100"
                  onClick={() => setActiveTab("WorkSamples")}
                >
                  Back
                </p>
                <button className="next-button w-100" type="submit">
                  {loading ? (
                    <LoginLoaderButton />
                  ) : updateindex !== null ? (
                    "Save and Publish"
                  ) : (
                    "Save and Publish"
                  )}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default PricingTerms;
